var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"px-2 py-1 font-button rounded uppercase transition-colors duration-100",class:_vm.classes,attrs:{"type":_vm.type || 'button'}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }